import dayjs, { Dayjs } from "dayjs"
import utc from "dayjs/plugin/utc"
dayjs.extend(utc)

/**
 * Convert a Dayjs (local) to canonical ISO/Z for API (UTC)
 */
export const toIsoStringUTC = (d: Dayjs): string => d.toISOString()

/**
 * Convert incoming server ISO/Z (or UTC string) to a local Dayjs for UI.
 * Returns null for falsy input.
 */
export const parseIsoToLocal = (iso?: string | null): Dayjs | null =>
  iso ? dayjs(iso).local() : null

/**
 * Convert ISO or Dayjs to DB DATETIME string in UTC (YYYY-MM-DD HH:mm:ss)
 * Return null if input falsy.
 */
export const toDbDatetimeUTC = (input?: Dayjs | string | null): string | null => {
  if (!input) return null
  const iso = typeof input === "string" ? input : (input as Dayjs).toISOString()
  return dayjs.utc(iso).format("YYYY-MM-DD HH:mm:ss")
}

/**
 * UI display format helper
 */
export const formatForDisplay = (d?: Dayjs | null, fmt = "MM-DD-YYYY hh:mm a"): string =>
  d ? d.format(fmt) : ""